import { DataResponse } from 'services/response';
import { BASE_API_URL } from "utils/constants";
import { get, post } from '../../utils/api';


export type UnfollowRemind = {
  stt: string, email: string, id: string
}
// ============ Khai báo phương thức =====================
export interface IUnfollowRemindServices {
  // danh sách nhắc nhở
  searchData(data: object): Promise<DataResponse<UnfollowRemind[]>>
  // create
  create(data: object): Promise<DataResponse<null>>
  // delete
  delete(id: string): Promise<DataResponse<null>>

}
// Hàm khởi tạo các phương thức service
export function createUnfollowRemindServices(): IUnfollowRemindServices {
  return {
    //  data từng tiêu chí
    searchData: async (data) => {
      return (await post(BASE_API_URL, `RemindWarranty/list-unfollow`, data)).data;
    },
    // create
    create: async (data) => {
      return (await post(BASE_API_URL, `RemindWarranty/create-unfollow`, data)).data;
    },
    // delete
    delete: async (id) => {
      return (await get(BASE_API_URL, `RemindWarranty/delete-unfollow`, {
        id: id
      })).data;
    },
  };
}
